import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShare = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.5 10.8333V12.1667C17.5 14.0333 17.5 14.9667 17.1367 15.68C16.8171 16.3072 16.3072 16.8171 15.68 17.1367C14.9667 17.5 14.0333 17.5 12.1667 17.5H7.83333C5.96667 17.5 5.03333 17.5 4.32 17.1367C3.69282 16.8171 3.18291 16.3072 2.86333 15.68C2.5 14.9667 2.5 14.0333 2.5 12.1667V10.8333M6.66667 5.71333C7.48552 4.58945 8.43964 3.57068 9.5075 2.68C9.64544 2.56404 9.81979 2.50032 10 2.5M10 2.5C10.1802 2.50032 10.3546 2.56404 10.4925 2.68C11.5604 3.57068 12.5145 4.58946 13.3333 5.71333M10 2.5V13.3333",
		stroke: "#3F3F46",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgShare);
export default ForwardRef;
